export default __webpack_public_path__ + "static/media/ITR-3.d9dca82b.png";